<template>
  <div class="background">
    <div class="aula-onboarding">
      <b-container>
        <b-row class="header noaccess">
          <b-col cols="12" class="aula-logo">
            <div class="logo">
              <i class="icon-Logo" aria-hidden="true" />
            </div>
          </b-col>
        </b-row>
        <b-row class="onboarding noaccess">
          <b-col cols="12" class="p-0 onboarding-wrapper">
            <div class="onboard-content">
              <h1>{{ noaccessTitle }}</h1>
              <a href="/auth/logout.php">{{ noaccessLink }}</a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noaccessTitle: null,
      noaccessLink: null,
    };
  },
  mounted() {
    const type = this.$route.query.type;
    switch (type) {
      case 'unauthorized':
        document.title = this.$getText('UNAUTHORIZED_PAGE_TITLE');
        this.noaccessTitle = this.$getText('UNAUTHORIZED_TITLE');
        this.noaccessLink = this.$getText('UNAUTHORIZED_LINK');
        break;
      case 'deactivatedUser':
        document.title = this.$getText('DEACTIVATED_USER_TITLE');
        this.noaccessTitle = this.$getText('DEACTIVATED_USER_TITLE');
        this.noaccessLink = this.$getText('NO_ACCESS');
        break;
      case 'accessNotGrantedYet':
        document.title = this.$getText('ACCESS_NOT_GRANTED_YET_PAGE_TITLE');
        this.noaccessTitle = this.$getText('ACCESS_NOT_GRANTED_YET_TITLE');
        this.noaccessLink = this.$getText('ACCESS_NOT_GRANTED_YET_LINK');
        break;
      case 'missingUserSystemRole':
        document.title = this.$getText('MISSING_USER_SYSTEM_ROLE_PAGE_TITLE');
        this.noaccessTitle = this.$getText('MISSING_USER_SYSTEM_ROLE_TITLE');
        this.noaccessLink = this.$getText('MISSING_USER_SYSTEM_ROLE_LINK');
        break;
      default:
        document.title = this.$getText('NO_ACCESS_PAGE_TITLE');
        this.noaccessTitle = this.$getText('COULD_NOT_LOGIN');
        this.noaccessLink = this.$getText('NO_ACCESS');
        break;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '../../assets/scss/core/variables' as *;
@use '../../assets/scss/core/breakpoints' as *;
@use '../../assets/scss/components/login/onboarding' as *;
</style>
